import classnames from 'classnames';
import React, { useMemo } from 'react';
import { isUndefined } from 'lodash/fp';

import styles from './Fields.module.scss';
import { SignOffConversation } from '../store';
import { SignOffConversationIcon } from '../sign-off/SignOffConversationIcon';
import { CustomTooltip } from '../../../shared/tooltip';

interface ReadOnlyBlacklineFieldProps {
    id: string;
    value: string;
    previousValue: string;
    signOffConversation?: SignOffConversation;
}

export const ReadOnlyBlacklineField: React.FC<ReadOnlyBlacklineFieldProps> = ({
    id,
    value,
    previousValue,
    signOffConversation
}) => {
    const showFieldUpdated = useMemo(() => value !== previousValue, [value, previousValue]);
    const content = useMemo(() => {
        if (value.length === 0 && previousValue.length === 0) {
            return 'No value provided';
        }
        if (value === previousValue) {
            return value;
        }
        return <div className={styles.updatedInputWrapper}><span className={styles.previousValue}>{previousValue}</span><span className={styles.updatedValue}>{value}</span></div>;
    }, [value, previousValue]);

    return (
        <CustomTooltip overlayText={content}>
            <div className={styles.readOnlyBlacklineWrapper}>
                <div
                    data-testid={`opinion-blackline-${id}`}
                    className={classnames(styles.blacklineField, {
                        [styles.updatedInputField]: showFieldUpdated
                    })}
                >
                    {content}
                </div>
                {!isUndefined(signOffConversation) && <SignOffConversationIcon signOffConversation={signOffConversation} id={id} />}
            </div>
        </CustomTooltip>
    );
};
